<form [formGroup]="dataMappingForm" class="flex flex-col">
  <mat-form-field appearance="outline" class="flex-1-1-100">
    <mat-label>Data Mapping Name</mat-label>
    <input formControlName="dataMappingName" matInput>
    <mat-error *ngIf="dataMappingForm.get('dataMappingName').hasError('required')" class="m-b-5">
      Data Mapping Name Is Required
    </mat-error>
  </mat-form-field>
  <app-data-mapping-source-or-destination-selector
    [formControl]="source"
    (handleSelectionChange)="onSourceSelectionChange($event)"
    [data]="data"
    [hasSelectedValue]="false"
    class="flex flex-col"
    label="Select Source">
  </app-data-mapping-source-or-destination-selector>
  <app-data-mapping-source-or-destination-selector
    [formControl]="destination"
    (handleSelectionChange)="onDestinationSelectionChange($event)"
    [data]="data"
    [hasSelectedValue]="false"
    class="m-t-20 flex flex-col"
    label="Select Destination">
  </app-data-mapping-source-or-destination-selector>
</form>
